/* HelpHint — ícone `?` ao lado de um label, usando GlossaryTooltip.
 * Termo deve existir em lib/glossary.js.
 */
import { HelpCircle } from "lucide-react";
import GlossaryTooltip from "@/components/help/GlossaryTooltip";

export default function HelpHint({ term }) {
  return (
    <GlossaryTooltip term={term} className="!no-underline !decoration-transparent">
      <HelpCircle
        size={13}
        className="text-[var(--text-muted)] hover:text-[var(--gold)] transition"
        aria-label={`Ajuda: ${term}`}
      />
    </GlossaryTooltip>
  );
}
